<form
  id="rental-object-improvements-form"
  class="astral-stack-l"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <astral-masked-input
      inputMode="numeric"
      [control]="form.controls['performYear']"
      [mask]="yearMask"
    ></astral-masked-input>
    <astral-select [itemsSource]="months" [control]="form.controls['performMonth']"></astral-select>
    <astral-masked-input
      inputMode="numeric"
      [control]="form.controls['interval']"
      [mask]="monthMask"
      [helpText]="'RENTAL_OBJECT_IMPROVEMENTS.HELP_TEXT.INTERVAL'"
    ></astral-masked-input>
    <astral-masked-input
      inputMode="numeric"
      [control]="form.controls['stopYear']"
      [mask]="yearMask"
    ></astral-masked-input>

    <astral-input
      [span]="'full'"
      [control]="form.controls['description']"
      [helpText]="'RENTAL_OBJECT_IMPROVEMENTS.HELP_TEXT.DESCRIPTION'"
    ></astral-input>
    <app-money-box
      class="astral-layout-item"
      [control]="form.controls['cost']"
      [helpText]="'RENTAL_OBJECT_IMPROVEMENTS.HELP_TEXT.COST'"
    ></app-money-box>
    <astral-checkbox
      [control]="form.controls['valueRaisingAction']"
      [helpText]="'RENTAL_OBJECT_IMPROVEMENTS.HELP_TEXT.VALUE_RAISING_ACTION'"
    ></astral-checkbox>
  </astral-layout-group>

  <div class="astral-form-actions astral-form-actions--start">
    <astral-button variant="primary" type="submit" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
